import classNames from 'classnames/bind';

export const mergeClassNames = (classNamesObject, inheritedClassesString) => {

    if (inheritedClassesString) {

        let inheritedClassNamesObject = {};

        let inheritedClassesArray = inheritedClassesString.split(' ');

        for (let i = 0; i < inheritedClassesArray.length; i++) {

            inheritedClassNamesObject[inheritedClassesArray[i]] = true;
        }

        return Object.assign({}, classNamesObject, inheritedClassNamesObject);
    }

    return classNamesObject;
};

export const getClasses = (styleNameMappings, conditionalStylesToApply, generatedClassesToApply) => {

    let cx = classNames.bind(styleNameMappings);

    return cx(mergeClassNames(conditionalStylesToApply, generatedClassesToApply));
};

export default {
    mergeClassNames
};


// WEBPACK FOOTER //
// ./services/stylingUtilities.js